import React, { useRef } from 'react';
import { Plus } from 'lucide-react';
import { useUploadImage } from '@/hooks';
import { ImageDestinationEnum } from '@sportspredict/shared';
import { useSignUp } from '../../contexts/signup.context';
import SP from '@/assets/images/logo/SP.svg';

export const AvatarUploading = () => {
	const fileInputRef = useRef(null);
	const { UploadImage, compressedImgData } = useUploadImage();
	const {
		setImageId,
		setImgVariants,
		preview,
		setPreview,
		isAvatarUploading,
		setIsAvatarUploading,
	} = useSignUp();

	const handleUploadClick = () => {
		fileInputRef.current?.click();
	};

	const handleFileChange = async (event) => {
		const file = event.target.files?.[0];
		if (!file) return;

		try {
			setIsAvatarUploading(true);
			setPreview(URL.createObjectURL(file));
			await UploadImage(file, ImageDestinationEnum.Users);
		} catch (error) {
			console.error('Image upload failed', error);
			setIsAvatarUploading(false);
		}
	};

	React.useEffect(() => {
		if (compressedImgData?.originalId && compressedImgData?.originalUrl) {
			setPreview(compressedImgData.originalUrl);
			setImageId(compressedImgData.originalId);
			setImgVariants(compressedImgData.variants);
			setIsAvatarUploading(false);
		}
	}, [compressedImgData, setImageId]);

	const handleRemovePhoto = () => {
		setPreview(null);
		setImageId('');
		setImgVariants(null);
		if (fileInputRef.current) fileInputRef.current.value = '';
	};

	return (
		<div className="flex flex-col items-center gap-4">
			<div className="relative select-none">
				<div
					onClick={handleUploadClick}
					className="w-[94px] h-[96px] rounded-[64px] bg-linear-to-b from-[#1F4A94] to-[#0A172E] flex items-center justify-center cursor-pointer relative overflow-hidden shadow-lg transition-transform hover:scale-105 duration-200"
				>
					{preview ? (
						<img src={preview} alt="Avatar" className="w-full h-full object-cover rounded-full" />
					) : (
						<img
							src={SP}
							alt="SP"
							className="w-[45px] h-[45px] object-contain opacity-90 mix-blend-color-dodge"
						/>
					)}
					{isAvatarUploading && (
						<div className="absolute inset-0 bg-black/40 flex items-center justify-center">
							<div className="loader" />
						</div>
					)}
					<input
						type="file"
						accept="image/*"
						ref={fileInputRef}
						onChange={handleFileChange}
						className="hidden"
					/>
				</div>
				<button
					type="button"
					onClick={handleUploadClick}
					className="absolute bottom-0 right-0 w-10 h-10 bg-blue-custom-2 rounded-full flex items-center justify-center text-white border-2 border-[#101423] hover:bg-blue-custom-2/90 transition shadow-lg hover:scale-110 active:scale-95 duration-200"
				>
					<Plus className="w-5 h-5 stroke-[2.5]" />
				</button>
			</div>
			{preview && (
				<button
					type="button"
					onClick={handleRemovePhoto}
					className="border border-red-500/50 hover:bg-red-500/10 text-[#F7F7F8] rounded-full px-4 py-1 text-xs font-bold transition"
				>
					Remove Photo
				</button>
			)}
		</div>
	);
};
